function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrackets = function SvgBrackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.211 72.54"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M97.371-145.08c0-10.6-7.533-17.019-16.74-17.019a10.5 10.5 0 0 0-5.58 1.4c.279-11.439 8.649-24.273 20.925-27.063v-13.118c-9.484 1.016-21.126 6.658-28.966 18.533-4.823 7.3-8.141 17.353-8.141 30.292 0 15.9 9.486 23.715 20.367 23.715 10.323 0 18.135-7.533 18.135-16.74zm-47.709 0c0-10.6-7.533-17.019-16.74-17.019a10.5 10.5 0 0 0-5.58 1.4c.279-11.439 8.649-24.273 20.925-27.063v-13.118c-15.624 1.674-37.107 15.9-37.107 48.825 0 15.9 9.486 23.715 20.367 23.715 10.323 0 18.135-7.533 18.135-16.74z",
    "data-name": "Path 32193",
    style: {
      fill: "#7c8196",
      opacity: 0.1
    },
    transform: "rotate(180 48.686 -64.17)"
  }));
};
export default SvgBrackets;